/**
 * 从url获取参数
 * @param variable
 * @returns {*}
 */
export function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] === variable) {
            return pair[1];
        }
    }
    return false;
}

/**
 * 已知value获取Object的key
 * @param object
 * @param value
 * @returns {*}
 */
export function findKey(object, value) {
    for (let key in object) {
        if (value === object[key]) {
            return key
        }
    }
    return null;
}

/**
 * 从Object移除value为空或者null的键值对
 * @param object
 * @returns {*}
 */
export function removeEmptyItem(object) {
    for (var key in object) {
        if (object[key] === '' || object[key] === null) {
            delete object[key]
        }
    }
    return object
}

/**
 * 打开外链提示
 * @param href
 */
export function openOutLink(href) {
    var tip = "您访问的链接即将离开\"汕尾市公共资源交易中心\"门户网站 是否确定？";
    if (confirm(tip)) {
        window.open(href);
    }
}

function dateFtt(fmt, date) { //author: meizz
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

function getDay(d) {
    var weekday = new Array(7)
    weekday[0] = "星期天"
    weekday[1] = "星期一"
    weekday[2] = "星期二"
    weekday[3] = "星期三"
    weekday[4] = "星期四"
    weekday[5] = "星期五"
    weekday[6] = "星期六"
    return weekday[d.getDay()];
}

export function getNow() {
    var d = new Date()
    let now = dateFtt("yyyy年M月d日", d) + " " + getDay(d);
    console.log(now)
    return now;
}

/**
 * param 将要转为URL参数字符串的对象
 * key URL参数字符串的前缀
 * encode true/false 是否进行URL编码,默认为true
 *
 * return URL参数字符串
 */
export function urlEncode(param, key, encode) {
    if (param == null) return '';
    let paramStr = '';
    let t = typeof (param);
    if (t === 'string' || t === 'number' || t === 'boolean') {
        paramStr += '&' + key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param);
    } else {
        for (let i in param) {
            let k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
            paramStr += urlEncode(param[i], k, encode);
        }
    }
    return paramStr;
}

import URL from "@/core/globalUrl"

export function getShowFjUrl(domain, id, type, idType) {
    if (id != null) {
        if (idType === "PATH") {
            return URL.FILE + id;
        }
        let params = {domain: domain, id: id, type: type, idType: idType};
        return URL.API + "/api/common/download?" + urlEncode(params).substr(1);
    }
    return null;
}

export function isAssetTypeAnImage(filePath) {
    if (filePath === null || filePath === undefined) {
        return false;
    }
    //获取最后一个.的位置
    var index = filePath.lastIndexOf(".");
    //获取后缀
    var ext = filePath.substr(index + 1);
    return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1;
}

// 下载文件
export function downloadFile (url, fileName) {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = () => {
        if (xhr.status === 200) {
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(xhr.response);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
        }
    };
    xhr.send();
}
